export function useOrganizationId() {
  const route = useRoute();
  const router = useRouter();
  
  // Get organization ID from route params, with fallback to 1
  const organizationId = computed(() => {
    const paramId = parseInt(route.params.organizationId as string);
    return Number.isInteger(paramId) && paramId > 0 ? paramId : 1;
  });

  // Function to navigate to a different organization
  const setOrganizationId = (newOrgId: number) => {
    const currentPath = route.path;
    const newPath = currentPath.replace(/^\/organizations\/(\d+\/?)?/, `/organizations/${newOrgId}/`);
    router.push(newPath);
  };

  return {
    organizationId: readonly(organizationId),
    setOrganizationId
  };
}